import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { AppState } from 'app/store/app.states';

@Component({
  selector: 'app-guia-identificacion',
  templateUrl: './guia-identificacion.component.html',
  styleUrls: ['./guia-identificacion.component.scss']
})
export class GuiaIdentificacionComponent implements OnInit {
    //@OUTPUTS
    @Output() FormGuiaIdentificacionEventEmiter = new EventEmitter<any>();
    //@INPUTS
    @Input() title: any;
    @Input() data: any;
    //Formularios
    idguiatransporte;
    FormGuiaIdentificacion =      new FormGroup({
        numero:             new FormControl('',[Validators.required]),
        descripcion:         new FormControl('',[Validators.required]),
        peso:               new FormControl('',[Validators.required]),
    });
    data_impreg = [];
    constructor(
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService
    ) { }

    ngOnInit(): void {
        this.senddata();
        if(Object.keys(this.data).length){
            this.asignar_valores();
        }
    }
    asignar_valores(){
        this.FormGuiaIdentificacion.controls.numero.setValue(this.data.NumeroGuiaIdentificacion);
        this.FormGuiaIdentificacion.controls.descripcion.setValue(this.data.DescripGuiaIdentificacion);
        this.FormGuiaIdentificacion.controls.peso.setValue(this.data.PesoGuiaIdentificacion);
    }
    senddata(){
        this.FormGuiaIdentificacion.statusChanges.subscribe(status => {
            if(this.FormGuiaIdentificacion.valid){
                let data = {identificacion : this.FormGuiaIdentificacion.value,title : this.title}
                this.FormGuiaIdentificacionEventEmiter.emit(data);
            }
        });
    }

}
